import { memo } from 'react'
import Icon, { IconName } from '~components/ui/icon'
import { cn } from '~utils/cn'

interface AppPortalButtonProps {
  icon: IconName
  title: string
  description: string
  onClick: () => void
  className?: string
  iconClassName?: string
  theme?: 'primary' | 'yellow'
  buttonText?: string
}

const AppPortalButton = ({
  icon,
  title,
  description,
  onClick,
  className,
  iconClassName,
  theme = 'primary',
  buttonText,
}: AppPortalButtonProps) => {
  return (
    <button
      className={cn(
        'w-full rounded-[20px] min-h-[94px] p-4 flex items-center justify-center flex-gap-x-5',
        {
          'bg-primary-600': theme === 'primary',
          'bg-extended-yellow dark:bg-gray-800': theme === 'yellow',
        },
        className
      )}
      onClick={onClick}
    >
      <div className="rounded-full bg-white w-[52px] h-[52px] flex items-center justify-center flex-shrink-0">
        <Icon name={icon} className={cn('size-8', iconClassName)}></Icon>
      </div>
      <div className="flex flex-col items-start justify-start flex-1 w-full flex-gap-y-2">
        <p
          className={cn('text-title-2 hs:text-title-1', {
            'text-white': theme === 'primary',
            'text-primary-600 dark:text-white': theme === 'yellow',
          })}
        >
          {title}
        </p>
        <p
          className={cn(
            'text-white text-body-3 hs:text-body-2 text-start whitespace-normal sm:whitespace-pre-line leading-[1.25]',
            {
              'text-white dark:text-gray-300': theme === 'primary',
              'text-primary-600 dark:text-gray-300': theme === 'yellow',
            }
          )}
        >
          {description}
        </p>
        {buttonText && (
          <div
            className={cn(
              'flex items-center flex-gap-x-1 border rounded-2xl py-[2px] pl-2 pr-[6px]',
              {
                'border-white': theme === 'primary',
                'border-primary-600 dark:border-white': theme === 'yellow',
              }
            )}
          >
            <p
              className={cn('text-label-2 hs:text-label-1', {
                'text-white': theme === 'primary',
                'text-primary-600 dark:text-white': theme === 'yellow',
              })}
            >
              {buttonText}
            </p>
            <Icon
              name="arrow_right"
              className={cn('size-4', {
                'fill-white': theme === 'primary',
                'fill-primary-600 dark:fill-white': theme === 'yellow',
              })}
            />
          </div>
        )}
      </div>
    </button>
  )
}

AppPortalButton.displayName = 'AppPortalButton'
export default memo(AppPortalButton)
